var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.facet.name && _vm.facet.type !== "price"
    ? _c("div", { staticClass: "card", class: _vm.facet.cssClass }, [
        _c(
          "div",
          {
            staticClass: "h3 title",
            attrs: {
              "data-toggle": "collapse",
              href: "#collapse" + _vm.facet.name,
              role: "button",
              "aria-expanded": "false",
              "aria-controls": "#collapse" + _vm.facet.name
            }
          },
          [_vm._v(_vm._s(_vm.facetName))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-check-wrapper collapse",
            attrs: { id: "collapse" + _vm.facet.name }
          },
          [
            _vm.facet.name == "Marke"
              ? _c("div", { staticClass: "manufacturer mb-3 mr-3" }, [
                  _vm.facet.values.length > 7
                    ? _c("input", {
                        staticClass: "w-100 input-manufacturer py-2 px-3",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$translate(
                            "sockenrauschVueTheme::Catview.FilterSearchInput"
                          )
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.facets, function(value) {
              return _c("div", { key: value.id, staticClass: "form-check" }, [
                _c("input", {
                  staticClass: "form-check-input",
                  class: value.cssClass,
                  attrs: {
                    id: "option-" + value.id + "-" + _vm._uid,
                    type: "checkbox",
                    disabled: _vm.isLoading || value.count <= 0
                  },
                  domProps: { checked: _vm.isSelected(value.id) },
                  on: {
                    change: function($event) {
                      return _vm.updateFacet(value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "form-check-label w-100",
                    class: [
                      _vm.paddingClasses,
                      _vm.isSelected(value.id) ? "bg-appearance" : "",
                      "option-" + value.id
                    ],
                    style: _vm.paddingInlineStyles,
                    attrs: { for: "option-" + value.id + "-" + _vm._uid }
                  },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("span", { staticClass: "flex-grow-1 value" }, [
                        _vm._v(_vm._s(value.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-badge text-right" }, [
                        _vm._v(_vm._s(value.count))
                      ])
                    ])
                  ]
                )
              ])
            })
          ],
          2
        )
      ])
    : _vm.facet.type === "price"
    ? _c("div", { staticClass: "mt-3" }, [_c("item-filter-price")], 1)
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }